import { render, staticRenderFns } from "./ComingSoonView.vue?vue&type=template&id=4f1b66da&"
import script from "./ComingSoonView.vue?vue&type=script&lang=js&"
export * from "./ComingSoonView.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoonView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports